import { preferencesConfigAction } from './actions';
import compassStore from './store';

const compassActions = {
  preferencesConfigAction,
};

export { compassStore, compassActions };
